/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { LoadingService } from "../../../core/loader/loading.service";
import { NotificationService } from "../../../shared/components/notification/notification.service";
import { LoginLayoutData } from "../index-layout/index-layout.type";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  readonly environment = environment;
  forgotForm: FormGroup;
  hostname: string;
  loading$ = this.loader.loading$;
  submitted = false;
  layoutData: LoginLayoutData = {
    image: "assets/GlobeLogo.svg",
    /*title: "Forgot Password",*/
    instructions: "Enter email associated with your account: ",
  };

  constructor(
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private loader: LoadingService,
    private router: Router,
    private formBuilder: FormBuilder,
    public location: Location,
  ) {
    this.hostname = window.location.hostname;
  }

  ngOnInit(): void {
    if (this.authenticationService.currentUserInfo) {
      this.router.navigate(["/"]);
    }
    this.forgotForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  goBack(): void {
    this.location.back();
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.forgotForm.invalid) {
      return;
    }

    this.loader.show();

    const { email } = this.forgotForm.value || {};

    this.authenticationService
      .requestForgotPassword(email)
      .subscribe(
        () => {
          this.forgotForm.reset();
          this.notificationService.success("We have just sent you a link to reset your password");
          this.router.navigate(["/login"]);
        },
        (err) => {
          const message = err?.message || err;
          this.notificationService.error(message || "An error has ocurred");
        },
      )
      .add(() => this.loader.hide());
  }

  /** shortcut for form controls */
  get f() {
    return this.forgotForm.controls;
  }
}
